//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
import "../no/SelectPoint.js";
import "../no/SelectCartesianCoordinateSystem.js";
import "../no/SelectICurve.js";
import "../GeometricUtilities/GeometricUtilities.CurveLimitsData.js";
import "../no/SelectDisplayableObjectList.js";
import "../GeometricUtilities/GeometricUtilities.SupportPlaneData.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[1,"EndAngle",0,"Expression",0],[1,"EndAtAngle",0,"SelectDisplayableObject",0],[1,"EndInferredConstraint",0,"SelectObject",0],[1,"EndNormal",0,"SelectDisplayableObject",1],[1,"EndPoint",0,"SelectPoint",0],[0,"EndPointOptions",1,0],[0,"EndPointReference",1,0],[1,"EndReferenceCsys",0,"SelectCartesianCoordinateSystem",0],[1,"EndTangent",0,"SelectICurve",0],[1,"Limits",0,"GeometricUtilities.CurveLimitsData",0],[1,"LineEndNormal",0,"SelectDisplayableObjectList",0],[1,"LineStartNormal",0,"SelectDisplayableObjectList",0],[1,"StartAngle",0,"Expression",0],[1,"StartAtAngle",0,"SelectDisplayableObject",0],[1,"StartInferredConstraint",0,"SelectObject",0],[1,"StartNormal",0,"SelectDisplayableObject",1],[1,"StartPoint",0,"SelectPoint",0],[0,"StartPointOptions",1,0],[0,"StartPointReference",1,0],[1,"StartReferenceCsys",0,"SelectCartesianCoordinateSystem",0],[1,"StartTangent",0,"SelectICurve",0],[1,"SupportPlaneData",0,"GeometricUtilities.SupportPlaneData",0]],[],[]];
SPLM.Features.AssociativeLineBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AssociativeLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AssociativeLineBuilder.StartOption = Object.freeze({
    "Inferred" : "Inferred", "Point" : "Point", "Tangent" : "Tangent", "AtAngle" : "AtAngle", "AlongXc" : "AlongXc", "AlongYc" : "AlongYc", "AlongZc" : "AlongZc", "Normal" : "Normal"});

SPLM.Features.AssociativeLineBuilder.StartReference = Object.freeze({
    "Wcs" : "Wcs", "Absolute" : "Absolute", "CordinatesSystem" : "CordinatesSystem"});

SPLM.Features.AssociativeLineBuilder.EndOption = Object.freeze({
    "Inferred" : "Inferred", "Point" : "Point", "Tangent" : "Tangent", "AtAngle" : "AtAngle", "AlongXc" : "AlongXc", "AlongYc" : "AlongYc", "AlongZc" : "AlongZc", "Normal" : "Normal"});

SPLM.Features.AssociativeLineBuilder.EndReference = Object.freeze({
    "Wcs" : "Wcs", "Absolute" : "Absolute", "CordinatesSystem" : "CordinatesSystem"});

export default SPLM;